import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Library.module.scss';
import CreationCard from '../../components/CreationCard/CreationCard';
import Icon from '../../components/Icon/Icon';
import { setTopNavbar } from '../../Reducers/actions/navbarActions';
import { fetchLibraryCreations } from '../../Reducers/actions/creationsActions';
import CreationSkeleton from '../../components/CreationCard/CreationSkeleton';

const RecentlyAdded = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const libraryCreations = useSelector(state => state.creation.libraryCreations || []);
  const loading = useSelector(state => state.creation.loadingLibrary);
  const userId = useSelector(state => state.auth.user?.user_id);
  const hasRequestedLibraryRef = useRef(false);

  const handleViewCreation = (creation_id) => {
    navigate(`/creations/${creation_id}`)
  }
  useEffect(() => {
    if (!userId) return;

    if (!libraryCreations?.length && !loading && !hasRequestedLibraryRef.current) {
      hasRequestedLibraryRef.current = true;
      dispatch(fetchLibraryCreations());
    }
  }, [dispatch, userId, libraryCreations?.length, loading]);

  useEffect(() => {
    hasRequestedLibraryRef.current = false;
  }, [userId]);

  useEffect(() => {
    return () => { hasRequestedLibraryRef.current = false; };
  }, []);

  useEffect(() => {
    dispatch(setTopNavbar({
      title: 'Recently Added',
      showBackArrow: true,
    }))
  }, []);

  if (loading) {
    return             [1, 2, 3].map((item) => <CreationSkeleton key={item} />)

  }

  return (
    <div>
      
      <div className={styles.savedSection}>
        <div className={styles.verticalCardList}>
          {loading ? (
            [1, 2, 3].map((item) => <CreationSkeleton key={item} />)
          ) : (
            libraryCreations && libraryCreations.length > 0 ? (
              <>
                {libraryCreations.map((item) => (
                  <CreationCard
                    key={item.creation_id}
                    title={item.title}
                    price={item.price}
                    thumbnailUrl={item.thumbnail_url}
                    category={item.category}
                    users={item.users}
                    tags={item.tags}
                    onClick={() => handleViewCreation(item.creation_id)}
                    media={item.media}
                  />
                ))}
                <div style={{ minHeight: 64 }} />
              </>
            ) : (
              <div className={styles.emptyState}>
                <Icon alias="library_v2" width={40} height={40} color="#d9d9d9" />
                <div className={styles.emptyText}>No recently added creations yet.</div>
              </div>
            )
          )}
        </div>
        <div style={{ marginBottom: '32px' }} />
      </div>
    </div>
  );
};

export default RecentlyAdded; 